/**
 * WorkshopDayDrawerRowTag — the tinted tree-type pill on a day-drawer row. Uses
 * the SAME `dotColor` the dense calendar's dot and tint use, so a tree type's
 * colour matches between the calendar cell and this row.
 */
import { dotColor, hexToRgba } from '../../../shared/workshopCalendarPicker';

import type { PickerWorkshop } from './pickerWorkshop';

export interface WorkshopDayDrawerRowTagProps {
  workshop: PickerWorkshop;
}

export function WorkshopDayDrawerRowTag({ workshop }: WorkshopDayDrawerRowTagProps) {
  const label = workshop.treeSpeciesName ?? workshop.typeName;
  const color = dotColor(label);
  return (
    <span
      className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-semibold"
      style={{ background: hexToRgba(color, 0.16), color }}
    >
      <i
        aria-hidden="true"
        style={{ width: 6, height: 6, borderRadius: '50%', background: color }}
      />
      {label}
    </span>
  );
}
